document.addEventListener("DOMContentLoaded", function () {
  let elements = document.querySelectorAll("[data-menu-experience]");

  if (elements.length > 0) {
    for (let i = 0; i < elements.length; i++) {
      let main = elements[i];

      main.addEventListener("click", function () {
        let element = main.parentElement.parentElement;
        let indicators = main.querySelectorAll("div");
        let child = element.querySelector("#menu");

        child.classList.toggle("show");
        indicators[0].classList.toggle("p-rotate-180");
      });
    }
  }

  const card = document.getElementById("cardBuy");
  const stopTarget = document.getElementById("gallery") || document.getElementById("send");
  const cardWrapper = card?.parentElement;

  if (!card || !stopTarget || !cardWrapper) return;

  const fixedOffsetTop = 150;

  function handleScrollCard() {
    if (window.innerWidth < 1024) return;

    const scrollY = window.scrollY;
    const cardHeight = card.offsetHeight;
    const stopTop = stopTarget.offsetTop;
    const wrapperTop = cardWrapper.offsetTop;

    const stopScroll = stopTop - cardHeight - fixedOffsetTop;

    if (scrollY >= stopScroll) {
      card.classList.remove("p-fixed");
      card.classList.add("p-absolute");
      card.style.top = `${stopScroll - wrapperTop}px`;
    } else {
      card.classList.remove("p-absolute");
      card.classList.add("p-fixed");
      card.style.top = "";
    }
  }

  window.addEventListener("scroll", handleScrollCard);
  window.addEventListener("resize", handleScrollCard);
  window.addEventListener("load", handleScrollCard);
  handleScrollCard();
});
